import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/page-not-found.png'


const _hoisted_1 = { class: "container-fluid fill-height" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-xl-4 col-lg-4 col-sm-12 col-md-6" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: "Page not found",
        width: "500"
      }),
      /*#__PURE__*/_createElementVNode("p", { class: "text--align-center text--size-4 color--orange" }, "Page Not Found!!")
    ])
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}